import { DictionaryEntity, PcsEntity } from '@app/pcs/models';
import { PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { gql } from 'apollo-angular';

export interface TrainInformation {
  dossierId: number;
  route: string;
  trainName: string;
  validPeriod: string;
  applicantAlignmentDirection: DictionaryEntity;
  imAlignmentDirection: DictionaryEntity;
}

export const trainInformationMapper = new PropertyNameMapper({
  route: 'route',
  trainName: 'trainName',
  validPeriod: 'validPeriod',
  applicantAlignmentDirection: 'evuTrassierungDirection',
  imAlignmentDirection: 'kmTrassierungDirection'
}, {entityName: PcsEntity.Dossier});

export const trainInformation = gql`
  fragment trainInformation on TrainInformation {
    dossierId
    route
    trainName
    validPeriod
    applicantAlignmentDirection {
      id
      description
    }
    imAlignmentDirection {
      id
      description
    }
  }
`;
